@let comments = selectors.commentsFor(itemRequest) | select:[];
@let messagesEnabled = messagesEnabledFor(itemRequest) | select:true;
@let hasLinkedCatalogRecord = selectors.hasLinkedCatalogRecordFor(itemRequest) | select:false;

<div #chatMessageList class="overflow-y-auto pr-2" [ngClass]="hasLinkedCatalogRecord ? 'max-h-[46.7rem]' : 'max-h-[25.7rem]'">
  @for (commentDateGroup of sortedCommentsByDateFor(comments) | select:[]; track commentDateGroup.date) {
    <div class="flex flex-col gap-6 pt-4 pb-5">
      <div class="w-full flex items-center px-4 gap-4">
        <hr class="grow border-outline-variant"/>
        <span class="text-body-medium text-on-surface-variant">{{ commentDateGroup.date | format: 'DATE_ONLY' }}</span>
        <hr class="grow border-outline-variant"/>
      </div>

      @for (comment of commentDateGroup.comments; track comment.id) {
        @if (selectors.commentUserIdFor(comment) | select) {
          <!-- Library Comments -->
          <mx-direct-message messageSide="LEFT" messageIconName="local_library"
                             iconClasses="text-on-surface-variant" iconBgClasses="bg-ref-neutral-95"
                             [messageBody]="selectors.commentCommentFor(comment) | select:''"
                             bodyClasses="border border-ref-neutral-70 bg-ref-neutral-95 rounded-bl-[0.35rem]"
                             [messageDate]="selectors.commentCreatedFor(comment) | select:''" dateClasses="text-on-surface-variant"/>
        } @else if (selectors.commentPatronIdFor(comment) | select) {
          <!-- Patron Comments -->
          <mx-direct-message messageSide="RIGHT" [messageIconText]="patronSelectors.initials | select:''"
                             iconClasses="text-primary" iconBgClasses="bg-surface-container-high"
                             [messageBody]="selectors.commentCommentFor(comment) | select:''"
                             bodyClasses="border border-primary bg-surface-container-high rounded-br-[0.35rem]"
                             [messageDate]="selectors.commentCreatedFor(comment) | select:''" dateClasses="text-on-surface-variant"/>
        }
      }
    </div>
  }
</div>

<!-- Text Input and submit button -->
<form [formGroup]="chatFormGroup" class="mt-6 pe-6" [matTooltip]="messagesEnabled ? '' : 'New messages are not allowed on this request.'"
      (ngSubmit)="onMessageSubmit()">
  <mx-base-form-field fieldName="message" overrideLabel="" [formGroup]="chatFormGroup" [control]="messageControl" [enabled]="messagesEnabled">
    <div class="flex flex-row items-center w-full">
      <input matInput type="text" [formControl]="messageControl" placeholder="Send message to librarian..." class="flex-grow"/>

      <mx-icon-button type="submit" icon="send" color="on-surface-variant" [enabled]="messagesEnabled && formSubmittable"/>
    </div>
  </mx-base-form-field>
</form>
